import React from 'react';
import { CircularTableWithChairs } from '../../../main/assets/svg/CircularTable';
import { CircularTableSixChair } from '../../../main/assets/svg/CircularTableSixChair';
import { CircularTableEightChair } from '../../../main/assets/svg/CircularTableEightChair';
import { RectangularTableWithChairs } from '../../../main/assets/svg/RoundedRectangleTable';
import { RectangularTableWithEightChairs } from '../../../main/assets/svg/RectangularTableWithEightChairs';
import { RectangularTableWithSixChairs } from '../../../main/assets/svg/RectangularTableWithSixChairs';


type TableProps = {
  tableId: number;
  status: 'available' | 'booked' | 'filled' | 'available-soon';
  timer?: string;
  tableCode?: string;
  table?:any;
  selected?: boolean;
  isRounded: boolean;
  onSelect: (id: number) => void;
};

const RestaurantTable: React.FC<TableProps> = ({ tableId, status,tableCode, timer, selected, table, isRounded, onSelect }) => {
  const shapeClass = Number(table.tableType) <= 3 ? 'rest-table-hitbox--round' : 'rest-table-hitbox--rect';

  return (
    <div className={`rest-table-hitbox ${shapeClass}`} onClick={() => onSelect(tableId)}>
      {table.tableType == 1 &&
        <CircularTableWithChairs table={table} tableId={tableId} tableCode={tableCode} status={status} timer={timer}  selected={selected} onClick={() => onSelect} />
      }
       {table.tableType == 2 &&
        <CircularTableSixChair table={table} tableId={tableId} tableCode={tableCode} status={status} timer={timer}  selected={selected} onClick={() => onSelect} />
      }
       {table.tableType == 3 &&
        <CircularTableEightChair table={table} tableId={tableId} tableCode={tableCode} status={status} timer={timer}  selected={selected} onClick={() => onSelect} />
      }
      {table.tableType == 4 &&
        <RectangularTableWithChairs table={table} tableId={tableId} tableCode={tableCode} status={status} timer={timer} selected={selected} onClick={() => onSelect} />
      }
       {table.tableType == 5 &&
        <RectangularTableWithSixChairs table={table} tableId={tableId} tableCode={tableCode} status={status} timer={timer} selected={selected} onClick={() => onSelect} />
      }
       {table.tableType == 6 &&
        <RectangularTableWithEightChairs table={table} tableId={tableId} tableCode={tableCode} status={status} timer={timer} selected={selected} onClick={() => onSelect} />
      }
       
    </div>
  );
};

export default RestaurantTable;
